import { render, staticRenderFns } from "./SupportView.vue?vue&type=template&id=0a18975e&scoped=true"
import script from "./SupportView.vue?vue&type=script&lang=js"
export * from "./SupportView.vue?vue&type=script&lang=js"
import style0 from "./SupportView.vue?vue&type=style&index=0&id=0a18975e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a18975e",
  null
  
)

export default component.exports